import React, { createContext, useEffect, useRef, useState } from 'react';
import { getempDetails } from '../../components/inboundCenter';
import { get_ak } from './emploginService';

const EmployeeContext = createContext();

export const EmployeeProvider = ({ children }) => {
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const hasFetched = useRef(false);

  const urlParams = new URLSearchParams(window.location.search);
  const empid = urlParams.get('empid');

  useEffect(() => {
      if (!empid || hasFetched.current) return;
      hasFetched.current = true;

      // Read all params at call time so we capture the URL state when empid is first available
      const p = new URLSearchParams(window.location.search);
      // Kept as the original ciphertext, never decrypted — this becomes the
      // `origNum` param SearchBar.js's changeURL() carries forward on every
      // subsequent navigation, so it must stay exactly what the URL gave us
      // rather than a plaintext value that would need re-encrypting later.
      const ONum = p.get('origNum') || p.get('phone') || "";
      const ucid = p.get('crtObjectId') || "";
      const type = p.get('type') || "";

      async function fetchEmployeeDetails() {
          try {
              // jwt_token is httpOnly now — unreadable from React. Node
              // injects the real value server-side into every upstream call
              // that needs it (see routes.js's AK-injection middleware), so
              // this always passes empty; callers must not gate on it being
              // truthy (gate on empid instead).
              let data = await getempDetails(empid, '');
              data['ak'] = '';
              data['empid'] = empid;
              data['ONum'] = ONum;
              data['ucid'] = ucid;
              data['type'] = type;
              setEmployeeDetails(data);
          } catch (error) {
              console.error('Error fetching employee details:', error);
          }
      }

      fetchEmployeeDetails();
  }, [empid]);

  return (
    <EmployeeContext.Provider value={employeeDetails}>
      {children}
    </EmployeeContext.Provider>
  );
};

export default EmployeeContext;
